<div *ngIf="checkpointsService.titleId <=9" class="progress">
    <img src='../../assets/images/Progress-bar-{{checkpointsService.titleId}}.png' attr.aria-label="current progress {{checkpointsService.getCurrentProgress()}}">
</div>
<div *ngIf="checkpointsService.titleId >9" class="progress">
    <img src='../../assets/images/Progress-bar-9.png' aria-label="current progress 100%">
</div>
